<div class="icon">
  <i class="fa-regular fa-ticket"></i>
</div>
<span class="font-medium-title-large font-color-black">
  {{ redeemedBy?.length }} Einlösungen</span
>
<ul>
  @for (redeemer of redeemedBy; track $index) {
    <li>
      <span class="font-regular-body-large font-color-black">{{
        redeemer.email
      }}</span>
    </li>
  }
</ul>
<div class="flex-r gap-16 justify-center padding-top-16">
  <button
    type="button"
    (click)="closeDialog()"
    class="inwi-icon-text-button-large-primary">
    <div class="button-content">
      <div class="button-icon">
        <i class="fa-regular fa-check-double"></i>
      </div>
      <div class="button-text">Verstanden</div>
    </div>
  </button>
</div>
